/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';
/**
 * Initial states of visual function are defined here
 */
export const initialState = {
  //
  loading: false,
  visualFilters: [],
  visualFilterById: [],
};
/**
 * All actions related to visual feature are defined here
 */
export const visualFilterSlice = createSlice({
  name: 'feature/visual-filter',
  initialState,
  reducers: {
    getVisualFilters(state) {
      state.loading = true;
    },
    getVisualFiltersSucceeded(state, action) {
      state.loading = false;
      state.visualFilters = action?.payload.results;
    },
    getVisualFiltersFailed(state) {
      state.loading = false;
    },
    createVisualFilter(state) {
      state.loading = true;
    },
    createVisualFilterSucceeded(state, action) {
      state.loading = false;
      state.visualFilters = [...state.visualFilters, action?.payload];
    },
    createVisualFilterFailed(state) {
      state.loading = false;
    },
    updateVisualFilter(state) {
      state.loading = true;
    },
    updateVisualFilterSucceeded(state, action) {
      state.loading = false;
      state.visualFilters = state?.visualFilters?.map((object) =>
        object?.id === action?.payload?.id ? { ...object, ...action.payload } : object
      );
    },
    updateVisualFilterFailed(state) {
      state.loading = false;
    },
    deleteVisualFilter(state) {
      state.loading = true;
    },
    deleteVisualFilterSucceeded(state, action) {
      state.loading = false;
      state.visualFilters = state?.visualFilters?.filter(
        (object) => object?.id !== action?.payload?.data?.id
      );
    },
    deleteVisualFilterFailed(state) {
      state.loading = false;
    },
    getVisualFilterById(state) {
      state.loading = true;
    },
    getVisualFilterByIdSucceeded(state, action) {
      state.loading = false;
      state.visualFilterById = action?.payload;
    },
    getVisualFilterByIdFailed(state) {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: visualFilterActions } = visualFilterSlice;
